import formatDate from 'vl-common/src/lib/formatDate';
import ServiceApi from 'vl-common/src/services/service.api';
import { Auth } from 'aws-amplify';

interface AllClinicianProps {
  payload: {
    clin_guid: string;
    patient_guid: string;
    subtype: string;
    datetime: Date;
    specarea: string;
    spec_cat: string;
    rows: number;
  }[];
}

export const allClinicians = ({ datetime, ...props }) => {
  const formattedDateTime =
    typeof datetime === 'string' ? datetime : formatDate(datetime, 'Date & Time (ISO 1806) - 2022-03-02T17:19:33.173Z');
  const request = datetime ? { datetime: formattedDateTime, ...props } : props;

  return async () => {
    const currentSession = await Auth.currentSession();
    const userGuid = await currentSession.getIdToken().payload.sub;

    const ret = await ServiceApi.get(`/clinicians/clinicians/${userGuid}`, {
      params: { gender: 'null', ...request }
    }).catch((e) => {
      console.log(e);
      throw e;
    });

    return { payload: ret.data.clinicians } as AllClinicianProps;
  };
};
